export const INPUT_FILE_TOTAL_SIZE = 5458;
